/** Rapporti espliciti: non creano genitori o generazioni per deduzione. */
export const relationKinds = [
  { key: 'sibling', label: 'Fratelli / sorelle', first: 'Prima persona', second: 'Fratello o sorella', directed: false },
  { key: 'cousin', label: 'Cugini / cugine', first: 'Prima persona', second: 'Cugino o cugina', directed: false },
  { key: 'aunt_uncle', label: 'Zio/a → nipote', first: 'Zio o zia', second: 'Nipote', directed: true },
  { key: 'friend', label: 'Amicizia', first: 'Prima persona', second: 'Amico o amica', directed: false },
  { key: 'custom', label: 'Altro rapporto', first: 'Prima persona', second: 'Seconda persona', directed: false },
] as const;
export const relationKind = (key?: string) => relationKinds.find((r) => r.key === key);
export const relationLabel = (link: { relationKind?: string; label?: string | null }): string =>
  link.label || relationKind(link.relationKind)?.label || link.relationKind || 'Altro rapporto';
